export class TabNotifiche {
    dataInserimento: string
    idTabNotifiche: number
    idUser: number
    notifica: string
    oggetto: string
}
